import { Component, inject, Input } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { UiKitModule } from "@app/ui-kit.module";
import { ProductImageComponent } from "@components/product-image/product-image.component";
import { Gas, LocalizeGasNamePipe } from "@domain/gas/gas";
import { LocalizeProductNamePipe, Product, ProductPropertyDimension } from "@domain/product/product";
import { ProductPriceData } from "@domain/product/product-price-data";
import { ProductService } from "@domain/product/product.service";
import { UserService } from "@domain/user/user.service";
import { map } from "rxjs";

@Component({
  selector: "app-configuration-wizard-header",
  templateUrl: "./configuration-wizard-header.component.html",
  styleUrls: ["./configuration-wizard-header.component.scss"],
  imports: [UiKitModule, ProductImageComponent, LocalizeProductNamePipe, LocalizeGasNamePipe],
  standalone: true,
})
export class ConfigurationWizardHeaderComponent {
  private productService = inject(ProductService);
  private userService = inject(UserService);

  private readonly showZrefPrices = toSignal(this.userService.user$.pipe(map((user) => user.showZrefPrices)), {
    initialValue: false,
  });

  @Input()
  product?: Product;

  dimensionsProperty?: ProductPropertyDimension;
  private readonly DIMENSIONS = "Dimensions_";

  protected priceData?: ProductPriceData;
  protected gas?: Gas;
  protected dimensions?: string;

  @Input()
  set data(data: any) {
    if (data instanceof Gas) {
      this.gas = data;
    } else if (data instanceof Product) {
      this.product = data;
      const regularPrice = this.productService.getPriceData(this.product);
      const zrefPrice = this.productService.getZrefPriceData(this.product);
      this.priceData = this.showZrefPrices() ? zrefPrice : regularPrice;
      if (this.product.type === "TRANSMITTER" || this.product.type === "GASWARNINGCENTER") {
        this.dimensionsProperty = this.product.getDimensionsPropertyByKey(this.DIMENSIONS);
        if (this.dimensionsProperty) {
          this.dimensions = this.dimensionsToString();
        }
      }
    }
  }

  @Input()
  showCosts: boolean = false;

  private dimensionsToString() {
    return (
      this.dimensionsProperty!.height * 1000 +
      "mm × " +
      this.dimensionsProperty!.width * 1000 +
      "mm × " +
      this.dimensionsProperty!.depth * 1000 +
      "mm"
    );
  }
}
